var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	1735: {
		fallback: () => (() => (__webpack_require__(6540))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	7405: {
		fallback: () => (() => (__webpack_require__(961))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	7531: {
		fallback: () => (__webpack_require__.e(839).then(() => (() => (__webpack_require__(2839))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	1867: {
		fallback: () => (__webpack_require__.e(546).then(() => (() => (__webpack_require__(6546))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@capacitor/core",

	},
	2000: {
		fallback: () => (Promise.all([__webpack_require__.e(452), __webpack_require__.e(169)]).then(() => (() => (__webpack_require__(5452))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bnimove/design-system",

	},
	9712: {
		fallback: () => (Promise.all([__webpack_require__.e(91), __webpack_require__.e(156)]).then(() => (() => (__webpack_require__(91))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bnimove/shared",

	},
	8383: {
		fallback: () => (__webpack_require__.e(142).then(() => (() => (__webpack_require__(5142))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@capacitor/filesystem",

	},
	2279: {
		fallback: () => (__webpack_require__.e(479).then(() => (() => (__webpack_require__(1479))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/styled",

	},
	9358: {
		fallback: () => (__webpack_require__.e(879).then(() => (() => (__webpack_require__(9879))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@reduxjs/toolkit",

	},
	9962: {
		fallback: () => (__webpack_require__.e(965).then(() => (() => (__webpack_require__(7965))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-redux",

	},
	4539: {
		fallback: () => (__webpack_require__.e(648).then(() => (() => (__webpack_require__(2648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	8594: {
		fallback: () => (() => (__webpack_require__(4848))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	8169: {
		fallback: () => (() => (__webpack_require__(5259))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	6178: {
		fallback: () => (() => (__webpack_require__(892))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	1265: {
		fallback: () => (() => (__webpack_require__(5184))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [1735];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"31": [
		2000,
		9712,
		8383,
		2279,
		9358,
		9962,
		4539,
		8594
	],
	"156": [
		6178,
		1265
	],
	"169": [
		8169
	],
	"405": [
		7405
	],
	"531": [
		7531
	],
	"792": [
		1735
	],
	"867": [
		1867
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}